import { Column } from 'primereact/column'
import { useState, useEffect, useRef, useImperativeHandle, forwardRef } from 'react';
import 'react-bootstrap-typeahead/css/Typeahead.css';
import BaseService from '../../../services/BaseService';
import CommonService from "../../../services/CommonService";
import DataGrid from '../../GenericComponents/DataGrid';

const CurrentIssueAuthorizations = forwardRef((props, ref) => {
  const {onDataFetch, reportId, reportType, tableType} = props;
  const [isLoading, setIsLoading] = useState(true);
  const [issueAuthorizations, setIssueAuthorizations] = useState([]); //Existing issuer authorizations in Issue Authorization table
  

  useEffect(() => {
    if (reportId){
      getIssueAuthorizationsByReportId(reportId);
    }
   
  }, [reportId]);


  const getIssueAuthorizationsByReportId = (selectedId) => {
    var obj = {
      msgId: null,
      sysId: null,
      opr: "getAuthorizationsByReportId", 
      hdrStruct: null,
      queryParam: null,
      reqData: {
        "id": selectedId,
        "reportType": reportType,
        "tableType": tableType,
      },
    };

    BaseService.processRequest(obj)
      .then((res) => res)
      .then((result) => {
        Object.keys(result.data.responses).forEach((key) => {
          setIssueAuthorizations(result.data.responses[key]);
          onDataFetch(result.data.responses[key]);
        });
        setIsLoading(false);
      });
  }

  
   useImperativeHandle(ref, () => {
      return {
        getIssueAuthorizationsByReportId
      };
  }, [])


  const columnsIssueAuthorizations = [{
    dataField: 'authorizationName',
    text: 'Authorization Name',
    sort: true,
  }, {
    dataField: 'authorizationDate',
    text: 'Authorization Date',
    sort: true,
    formatter: (row)=> CommonService.dateFormatter(row.authorizationDate),
  }, {
    dataField: 'originalAuthorizedAmt',
    text: 'Original Authorized Amount',
    sort: true,
    formatter: (row)=> CommonService.currencyFormatter(row.originalAuthorizedAmt),
  },{
    dataField: 'authorityReducedAmt',
    text: 'Authority Reduced Amount',
    sort: true,
    formatter: (row)=> CommonService.currencyFormatter(row.authorityReducedAmt),
  },  {
    dataField: 'authorityReplenishAmt',
    text: 'Authority Replenish Amount',
    sort: true,
    formatter: (row)=> CommonService.currencyFormatter(row.authorityReplenishAmt),
  }, 
  ];


  return (
    <div>
      <DataGrid
        title="Current Issue Authorizations:"
        dataSource={issueAuthorizations}
        sortField='authorizationId'
        showQuickSearch={false}
        emptyDataMessage='No data available to display'
      >
        {columnsIssueAuthorizations.map((column, i) => {
          return (
            <Column
              key={i}
              field={column.dataField}
              header={column.text}
              body={column.formatter}
              hidden={column.hidden}
            />)
        })
        }
      </DataGrid>
    </div>

  )
});

export default CurrentIssueAuthorizations;